export enum DateFormatType {
    US = "MM/DD/YYYY",
    EU = "DD/MM/YYYY",
}
